<div class="history-dialog">
  <div class="dialog-header">
    <h2>Previous Analysis - {{ data.projectName }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    @if (loading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading history...</p>
      </div>
    } @else if (error) {
      <div class="error-container">
        <mat-icon color="warn">error</mat-icon>
        <p>{{ error }}</p>
        <button mat-button (click)="loadVersions()">Retry</button>
      </div>
    } @else if (versions.length === 0) {
      <div class="empty-container">
        <mat-icon>history</mat-icon>
        <p>No previous analysis found for this project.</p>
      </div>
    } @else {
      <div class="versions-list">
        @for (version of versions; track version.id) {
          <div class="version-item" 
               [class.current-version]="isCurrentVersion(version)"
               [class.disabled-version]="isVersionDisabled(version)"
               (click)="!isVersionDisabled(version) && onCheckVersion(version)">
            <div class="version-info">
              <div class="version-name">
                <mat-icon>description</mat-icon>
                <span>{{ version.name }}</span>
                @if(isCurrentVersion(version)) {
                  <span class="current-badge">(Current)</span>
                }
              </div>
              <div class="version-meta">
                <span class="created-by">Created by: {{ version.created_by }}</span>
                <span class="created-at">{{ formatDate(version.created_at) }}</span>
                <span class="duration">Duration: {{ formatDuration(version.analysis_duration_seconds) }}</span>
              </div>
            </div>
            <div class="version-actions">
              <button 
                mat-raised-button 
                color="primary" 
                [disabled]="isVersionDisabled(version)"
                (click)="onCheckVersion(version); $event.stopPropagation()"
                class="check-button">
                <mat-icon>visibility</mat-icon>
                Check
              </button>
              <button 
                mat-icon-button 
                color="warn" 
                (click)="onDeleteVersion(version, $event)"
                class="delete-button"
                title="Delete version">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
